module.exports = __webpack_public_path__ + "static/media/YF103_5.ffd205a6.jpg";